"use client";

import { useEffect, useState } from "react";

/**
 * Mount gate — returns `false` on the server render and on the client's
 * first paint, then flips to `true` once the effect runs post-hydration.
 *
 * Why this exists: some client state (e.g. better-auth's `useSession()`
 * cookie cache) can resolve synchronously on some client renders but never
 * on the server render. Gating on `isPending` alone assumes the server pass
 * and the first client pass always agree — they don't, and the mismatch is a
 * React hydration error (#418) that discards and re-renders the whole tree.
 * Gating on this hook instead makes the first client render byte-identical
 * to SSR unconditionally, regardless of how fast any cache resolves.
 *
 * Originally duplicated in MobileNavMenu (#2608 audit, T2.4) and
 * NavbarAuth — consolidated here so the two copies can't drift.
 */
export function useHydrated(): boolean {
	const [hydrated, setHydrated] = useState(false);

	useEffect(() => {
		setHydrated(true);
	}, []);

	return hydrated;
}
